<div (cdkObserveContent)="onContentChange()">
  <ng-content></ng-content>
</div>
